export const getImgSrc = (file, type) => {
  if (type === 'image') {
    return URL.createObjectURL(file)
  } else if (type === 'video') {
    return './default_attachment_video.png'
  } else {
    return './default_attachment_file.png'
  }
}
